import { metricKeys } from '@pulse/metrics';
import { atom } from 'jotai';
import { DESC } from '@utils/table/constants';
import { getPotentialImprovementMetricKey } from './utils';

const defaultArchivedTabSortBy = {
  key: 'lastDetected',
  order: DESC,
};

// TODO: generalize this for more metrics to come
const defaultActiveTabSortBy = {
  key: getPotentialImprovementMetricKey(metricKeys.StreamingPerformanceIndex),
  order: DESC,
};

const tabAtom = atom('active');
const activeTabSortByAtom = atom(defaultActiveTabSortBy);
const archivedTabSortByAtom = atom(defaultArchivedTabSortBy);
const activeTabSearchTextAtom = atom('');
const archivedTabSearchTextAtom = atom('');

export {
  tabAtom,
  activeTabSortByAtom,
  archivedTabSortByAtom,
  activeTabSearchTextAtom,
  archivedTabSearchTextAtom,
};
